import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useHistory, useParams } from 'react-router-dom';
import { useCartDispatch } from '../../../components/context/CartContext';
import queryString from 'query-string';
import { omitBy, isEmpty } from 'lodash';
import useFetch from 'use-http';
import Page from '@/v2/components/Page';
import Filter from '../../../components/pages/ServicesPage/FilterNew/FilterNew';
import _ from 'lodash';

import InlineLoader from '../../../components/shared/InlineLoader/InlineLoader';
import { exponeaCapture } from '../../../components/hooks/exponeaCapture';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import ServicesContainer from './Components/ServicesContainer';
import { useCartData } from '../CartPage/context/CartDataContext';
import { SpecialistInfoCard } from '@/v2/components/SpecialistInfoCard/SpecialistInfoCard';
import { SpecialistInfoCardWithCalendar } from '@/v2/components/Calendar/SpecialistInfoCardWithCalendar';
const USE_MOCKS = false;

const CombinedServicesPage = (props) => {
  const { categoryId } = useParams();
  const { search: urlParams, state } = useLocation();
  const options = queryString.parse(urlParams);
  const [preselectedGroupId, setPreselectedGroupId] = useState(
    options?.groupId,
  );
  const [cityId, setCityId] = useState(null);
  const dispatch = useCartDispatch();
  const [orderedServiceGroups, setOrderedServiceGroups] = useState();
  const [selectedDepartmentFilter, setSelectedDepartmentFilter] = useState();
  const [selectedServiceFilter, setSelectedServiceFilter] = useState();

  const history = useHistory();
  const {
    loading: loadingFilters,
    error,
    data: filters = [],
  } = useFetch(
    `/Services/CombinedServicesFilter?departmentid=${selectedDepartmentFilter}&serviceId=${selectedServiceFilter}&holter=${
      options?.holter === undefined ? false : options?.holter
    }`,
    [
      selectedDepartmentFilter,
      selectedServiceFilter,
      history?.location?.state?.services,
      options?.holter,
    ],
  );

  const [initialFilters, setInitialFilters] = useState(filters);

  const { get: getServiceGroups, loading: getServiceGroupsLoading } = useFetch(
    '/Services/CombinedServicesGroups',
  );

  const { get: getGroupedCombinedServices, loading: groupedloadingServices } =
    useFetch('/Services/GroupedCombinedServices');

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [moreLoading, setMoreLoading] = useState(false);
  const [isActive, setIsActive] = useState();
  const [serviceGroups, setServiceGroups] = useState();
  const [externalServiceTypeId, setExternalServiceTypeId] = useState();
  const [selectedServiceGroup, setSelectedServiceGroup] = useState();
  const [serviceGroupedServices, setServiceGroupedServices] = useState();
  const [loadingGroup, setLoadingGroup] = useState(false);
  const [expandSingleGroup, setExpandSingleGroup] = useState();
  const [resetGroups, setResetGroups] = useState(false);
  const [serviceTitle, setServiceTitle] = useState(
    'Kompleksinės paslaugos, abonementai',
  );
  const [serviceGroupsLoading, setServiceGroupsLoading] = useState(true);
  const { setComplex, setService } = useCartData();

  const [visitPaymentTypeFilter, setVisitPaymentTypeFilter] = useState(
    options.visitPaymentTypeId,
  );

  function changeActiveState(idx) {
    setIsActive((state) => [...(state ?? [])]);
  }

  const { request: timeRequest, response: timeResponse } =
    useFetch(`/TimeSlots`);

  // useEffect(() => {
  //   console.log('options', options);
  // }, [options]);

  useEffect(() => {
    if (history?.location?.state?.services === 'holter') {
      setServiceTitle(history?.location?.state?.serviceTitle);
    }
  }, [history?.location?.state?.services]);

  useEffect(() => {
    if (!loadingFilters) {
      setServiceGroupsLoading(true);
      getServiceGroups(
        `?departmentId=${selectedDepartmentFilter}&serviceId=${selectedServiceFilter}&holter=${
          options?.holter == undefined ? false : options?.holter
        }`,
      ).then((res) => {
        setServiceGroups(res);
        setServiceGroupsLoading(false);

        if (res && res?.length === 1) {
          setSelectedServiceGroup(res[0].externalId);
        }
      });
    }
  }, [
    externalServiceTypeId,
    getServiceGroups,
    resetGroups,
    selectedDepartmentFilter,
    selectedServiceFilter,
    loadingFilters,
    options?.holter,
  ]);

  useEffect(() => {
    if (selectedServiceGroup) {
      setLoadingGroup(true);
      getGroupedCombinedServices(
        '?' +
          queryString.stringify({
            ...queryString.parse(history.location.search),
            groupId: selectedServiceGroup,
          }),
      ).then((data) => {
        if (!data) {
          setServiceGroupedServices([]);
          setLoadingGroup(false);
          return;
        }

        setServiceGroupedServices(data.services ? data.services : data);
        setLoadingGroup(false);
      });
    }
  }, [
    getGroupedCombinedServices,
    selectedServiceGroup,
    selectedDepartmentFilter,
    selectedServiceFilter,
  ]);

  useEffect(() => {
    let exponea = JSON.parse(sessionStorage.getItem('exponeaTrack') || '[]');
    if (exponea.length > 0) {
      exponea.push({ name: 'Registration status', value: 'Cancelled' });
      exponeaCapture(exponea, 'booking_item');
      sessionStorage.removeItem('exponeaTrack');
    }
    exponeaCapture(
      [
        { name: 'category_1', value: 'Paslaugų paketai' },
        { name: 'category_id', value: 3 },
      ],
      'view_item',
    );
  }, []);

  useEffect(() => {
    const searchWithoutQuestionMark = history.location.search.substring(1);
    const paramPairs = searchWithoutQuestionMark.split('&');
    const parsedParams = {};
    paramPairs.forEach((paramPair) => {
      const [paramName, paramValue] = paramPair.split('=');
      parsedParams[paramName] = paramValue;
    });
    setSelectedDepartmentFilter(parsedParams.departmentId);
    setSelectedServiceFilter(parsedParams.serviceId);
    if (parsedParams?.serviceId) {
      updateFilters({ value: parsedParams.serviceId, name: 'serviceId' });
    } else {
      updateFilters({ value: '', name: 'serviceId' });
    }
    if (parsedParams?.departmentId) {
      updateFilters({ value: parsedParams.departmentId, name: 'departmentId' });
    } else {
      updateFilters({ value: '', name: 'departmentId' });
    }
  }, [history.location.search]);

  useEffect(() => {
    delete filters['isPsdf'];
    setInitialFilters(filters);
  }, [filters]);

  function updateFilters({ value, name }) {
    const q = queryString.stringify(
      omitBy({ ...options, [name]: value }, isEmpty),
    );

    if (name === 'visitPaymentTypeId') {
      setVisitPaymentTypeFilter(value);
    }

    if (name === 'departmentId' && value) {
      setSelectedDepartmentFilter(value);
    } else if (name === 'departmentId' && !value) {
      setSelectedDepartmentFilter(undefined);
    }

    if (name === 'serviceId' && value) {
      setSelectedServiceFilter(value);
    } else if (name === 'serviceId' && !value) {
      setSelectedServiceFilter(undefined);
    }

    history.replace({ search: `?${q}` });
  }

  function getTitle() {
    return serviceTitle;
  }

  function formatPriceRange(prices = []) {
    const numericPrices = prices
      .map((p) => p.price)
      .filter((p) => typeof p === 'number');

    if (numericPrices.length === 0) return 'N/A';

    const min = Math.min(...numericPrices);
    const max = Math.max(...numericPrices);
    // Only show one price if all values are the same
    return min === max ? `${min} €` : `${min} € – ${max} €`;
  }

  const getTimeSlots = useCallback(
    (from, to, filter, workplaceId, serviceId) => {
      return timeRequest.get(
        `?WorkplaceId=${workplaceId}&DateFrom=${from}&DateTo=${to}&Filter=${filter}&serviceId=${serviceId}`,
      );
    },
    [timeRequest],
  );

  return (
    <Page
      error={(!data && !serviceGroups && !loadingFilters) || error}
      loading={loadingFilters}
    >
      <ServicesContainer marginTop={true}>
        <Page.Title backUrl={`/`} greyTheme={true} smallHeight={true}>
          {' '}
          {getTitle()}
        </Page.Title>
      </ServicesContainer>
      <Filter
        value={options}
        onChange={updateFilters}
        isLoading={loadingFilters}
        filters={initialFilters}
        onClear={() => history.push({ search: '' })}
        category={categoryId}
        isGrid={categoryId === '1'}
        enableSorting={false}
        disableSwitch={true}
      />

      <ServicesContainer>
        {serviceGroupsLoading ? (
          <div className="relative h-[400px]">
            <InlineLoader light={true} />
          </div>
        ) : serviceGroups && serviceGroups.length > 0 ? (
          <div className="mt-3">
            <Accordion
              type="single"
              collapsible
              value={selectedServiceGroup}
              onValueChange={(value) => {
                setSelectedServiceGroup(value ?? null);
                // setPage(1);
              }}
              className="mt-3"
            >
              {serviceGroups.map(({ externalId, name }) => (
                <AccordionItem key={externalId} value={externalId}>
                  <AccordionTrigger>{name}</AccordionTrigger>
                  <AccordionContent>
                    {selectedServiceGroup === externalId ? (
                      loadingGroup ? (
                        <InlineLoader light={true} />
                      ) : (
                        <>
                          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 justify-items-center mt-2">
                            {serviceGroupedServices
                              ?.filter((service) => service?.service)
                              .map((service, i) => (
                                <SpecialistInfoCard
                                  key={i}
                                  name={service.service.title}
                                  specialty="Paslaugų paketai"
                                  complex={true}
                                  infoItems={[
                                    {
                                      label: 'Galima PSDF kompensacija',
                                      value: 'Ne',
                                      align: 'left',
                                    },
                                    {
                                      label: 'Kaina',
                                      value: formatPriceRange(service.prices),
                                      align: 'right',
                                    },
                                  ]}
                                  categoryId={3}
                                  onSelect={() => {
                                    setComplex(service);
                                    history.push(
                                      '/kompleksines-paslaugos/cart',
                                      {
                                        departmentId: selectedDepartmentFilter,
                                      },
                                    );
                                  }}
                                />
                              ))}
                          </div>

                          {serviceGroupedServices
                            ?.filter((service) => !service?.service)
                            .map((service, i) => (
                              <SpecialistInfoCardWithCalendar
                                key={i}
                                service={service}
                                visitPaymentTypeFilter={visitPaymentTypeFilter}
                                urlParams={urlParams}
                                selectedDepartmentFilter={
                                  selectedDepartmentFilter
                                }
                                getTimeSlots={getTimeSlots}
                              />
                            ))}
                          {/* <CustomPagination
              page={page}
              setPage={setPage}
              pageCount={pageCount}
            /> */}
                        </>
                      )
                    ) : null}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        ) : null}
      </ServicesContainer>
    </Page>
  );
};

export default CombinedServicesPage;
